import { Message, MessageBox } from 'element-ui';
import Vue from 'vue';

import { isHTTPResponseException } from '@/exceptions/HTTPResponseException';
import { UserModule } from '@/store/modules/user';

export function errorHandler(error: Error, vm: Vue, info: any) {
  if (isHTTPResponseException(error) && error.unauthorized) {
    MessageBox.confirm('你的登录已经过期，尝试重新登录', '登出', {
      confirmButtonText: 'Relogin',
      cancelButtonText: 'Cancel',
      type: 'warning',
    }).then(() => {
      UserModule.ResetToken();
      location.reload();
    });
  } else {
    Message({
      message: (isHTTPResponseException(error) && error.dataMessage) || error.message,
      type: 'error',
      duration: 5 * 1000,
    });
  }
  throw error;
}
